import * as React from 'react';

export function IconChevronRight(): JSX.Element {
    return (
        <svg width="1em"
             height="1em"
             viewBox="0 0 16 16"
             shapeRendering="auto">
            <path fill="currentColor"
                  d="M6.44 12.032L5.192 10.384 8.296 8 5.192 5.568 6.44 3.968 10.808 7.376 10.808 8.624 6.44 12.032z"/>
        </svg>
    );
}
